import React, { useContext, useMemo } from "react";

interface SlotProps {
    slot?: string;
}

interface SlotWrapperProps {
    slot?: string;
    children: React.ReactElement;
}

export interface SlotsMap {
    [key: string]: {
        className: string;
    };
}

let SlotContext = React.createContext<SlotsMap>({});

export function useSlotProps<T>(props: T, defaultSlot = "text"): T {
    let slot = (props as SlotProps).slot || defaultSlot;
    let { [slot]: slotProps = {} } = useContext(SlotContext) || {};
    return Object.assign(slotProps, props);
}

export const SlotProvider = (props: { slots?: SlotsMap; children: any }) => {
    let parentSlots: SlotsMap = useContext(SlotContext);
    let { slots = {}, children } = props;

    // Merge props for each slot from parent context and props
    let value = useMemo(
        () => {
            const parent = parentSlots ?? [];
            return Object.keys(parent)
                .concat(Object.keys(slots))
                .reduce(
                    (o, p) => ({
                        ...o,
                        [p]: Object.assign(
                            parent[p] || {},
                            slots[p] || {}
                        ),
                    }),
                    {}
                )},
        [parentSlots, slots]
    );

    return (
        <SlotContext.Provider value={value}>{children}</SlotContext.Provider>
    );
};

export const SlotWrapper = (props: SlotWrapperProps) => {
    props = useSlotProps(props, "text");
    const { children, ...otherProps } = props;

    return React.cloneElement(children, {
        ...otherProps,
    });
};
